export var IInsiderReducerType;
(function (IInsiderReducerType) {
    IInsiderReducerType["INSIDER_TRADING"] = "insiderTrading";
    IInsiderReducerType["SUBSTANTIAL"] = "substantial";
    IInsiderReducerType["BULK_BLOCK"] = "bulkBlock";
})(IInsiderReducerType || (IInsiderReducerType = {}));
